import React, { ReactElement, useMemo } from 'react';
import WealthieBreadCrumb from '../../components/BreadCrumb';
import WealthieTable from '../../components/WelthieTable';
import { getGiftApi } from '../../api';
import { Link } from 'react-router-dom';

const breadcrumbConfig = [
  {
    name: 'Wealthie',
  },
  {
    name: 'Giftcards',
  },
];

function GiftCard(): ReactElement {
  const giftCollumns = useMemo(
    () => [
      {
        title: 'Amount',
        dataIndex: 'giftcard_amt',
        key: 'giftcard_amt',
      },
      {
        title: 'Sender Name',
        dataIndex: 'sender_name',
        key: 'sender_name',
      },
      {
        title: 'Internal Id',
        dataIndex: 'id',
        key: 'id',
        render: function renderGiftId(text: string, row: any) {
          return <Link to={`gift-card/${row.id}`}>{text}</Link>;
        },
      },
    ],
    [],
  );

  return (
    <>
      <WealthieBreadCrumb breadcrumbConfig={breadcrumbConfig} />
      <WealthieTable
        isShowLoadingOnStart
        rowKey="id"
        extraApiParams={[]}
        filterPagination="data.pagination.totalCount"
        filterData="data.data"
        api={getGiftApi}
        columns={giftCollumns}
      />
    </>
  );
}

export default GiftCard;
